var Handlebars = require('/var/lib/jenkins/jobs/wunderman_resolution/workspace/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<footer class=\"site-footer\">\n	<div class=\"content-wrapper\">\n		<div class=\"row\">\n			<div class=\" col vertical-center\">\n				<p class=\"text-right\">"
    + container.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data}) : helper)))
    + "</p>\n			</div>\n		</div>\n	</div>\n</footer>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/footer.hbs
// module id = 24
// module chunks = 0